export const DEMO_TYPE_SEARCH_PARAM = "type";

export const DemoType = {
  PROPENSITY: "propensity",
  NUMERIC_OUTCOME: "numeric-outcome",
  CATALOG_RECOMMENDATION: "catalog-recommendation",
  LOOKALIKE: "lookalike",
} as const;

export type DemoType = (typeof DemoType)[keyof typeof DemoType];

const DEMO_TYPES: ReadonlyArray<string> = Object.values(DemoType);

export const isDemoType = (value: string | null): value is DemoType =>
  value !== null && DEMO_TYPES.includes(value);

export const createDemoPath = (type: DemoType): string =>
  `create?${DEMO_TYPE_SEARCH_PARAM}=${type}`;
